module.exports = __webpack_public_path__ + "img/maintrucksm.ca109827.svg";